import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGraduationHat = () => {
  return (
    <g>
      <path d="M7.693 2.068a.75.75 0 0 1 .494-.042l.12.042 7.252 3.248a.75.75 0 0 1 .104 1.312l-.104.056-.31.138.001 3.204a.75.75 0 0 1-1.493.102l-.007-.102V7.494L13 7.83v3.929C13 12.903 10.38 14 8 14c-2.298 0-4.836-1.037-4.992-2.135L3 11.759v-3.93L.446 6.684a.75.75 0 0 1-.104-1.312l.104-.056 7.247-3.248zM4.5 8.5v3.036l.03.024c.14.103.337.216.573.325l.184.082c.79.332 1.75.538 2.713.538.965 0 1.926-.204 2.715-.535.254-.106.473-.22.64-.326l.113-.079.032-.026V8.502l-3.193 1.43a.75.75 0 0 1-.494.043l-.12-.042L4.5 8.5zM8 3.573 2.586 6 8 8.427 13.417 6 8 3.573z" />
    </g>
  );
};

export default withIcon(IconGraduationHat);
